import {emojiDefinitions, emojiImageSource, emojiImageSourceHexcode} from '../helper/emoji';
import 'fomantic-ui-less/definitions/modules/transition';
import 'fomantic-ui-less/definitions/modules/search';
import {suggestionsPlugin, triggerCharacter} from './suggestionsPlugin';

const suggestionsTrigger = function () {
    return $position => {
        const parent = $position.parent;
        if (parent && ['page_title', 'code_block'].includes(parent.type.name)) {
            return;
        }

        try {
          return triggerCharacter(":", {allowSpaces: true})($position);
        } catch (e) {}
    }
}

const applyEmoji = function (view, range, emoji) {
    if (view.composing) {
      return;
    }

    const text = emojiDefinitions.find(emojiDefinition => emojiDefinition.shortcodes.includes(emoji))?.unicode || emoji;

    const state = view.state;
    const tr = state.tr;
    const {from, to} = range;
    const node = state.schema.nodes.emoji.createAndFill({
        src: emojiImageSource(text),
        alt: text
    });

    tr.replaceWith(from, to, node);
    view.dispatch(tr);
    view.focus();
}

const emojiSource = emojiDefinitions.map(emojiDefinition => ({
    title: emojiDefinition.label,
    description: emojiDefinition.shortcodes.map(alias => `:${alias}:`).join(', '),
    image: emojiImageSourceHexcode(emojiDefinition.hexcode),
    text: emojiDefinition.shortcodes[0],
    category: emojiDefinition.group,
    keywords: emojiDefinition.tags.join(' ')
}));

const showEmojiList = function (view, range, text) {
    let emojiList = document.getElementById('emoji-tooltip');
    if (!emojiList) {
        emojiList = document.createElement("div");
        emojiList.id = 'emoji-tooltip';
        emojiList.className = 'ui horizontal category search tiny active focus scrolling';
        emojiList.innerHTML = '<input class="prompt" type="text" style="display: none"><div class="results"></div>';

        view.dom.parentNode.appendChild(emojiList);
    }

    $(emojiList).search({
        source: emojiSource,
        fullTextSearch: true,
        showNoResults: false,
        maxResults: 30,
        searchFields: [
            'title',
            'description',
            'category',
            'text',
            'keywords'
        ],
        type: 'category',
        transition: 'scale',
        duration: 0,
        onSelect: result => applyEmoji(view, range, result.text)
    }).search('search local', text);

    const {from} = range;
    const start = view.coordsAtPos(from);
    const {left: boxLeft, bottom: boxBottom} = emojiList.offsetParent.getBoundingClientRect();

    emojiList.style.left = start.left - boxLeft + "px";
    emojiList.style.bottom = (boxBottom - start.bottom) + "px";
}

export const emojiSuggestions = suggestionsPlugin({
    matcher: suggestionsTrigger(),
    onEnter({view, range, text}) {
        showEmojiList(view, range, text.slice(1));
        return false;
    },
    onChange({view, range, text}) {
        showEmojiList(view, range, text.slice(1));
        return false;
    },
    onExit() {
        const $emojiTooltip = $('#emoji-tooltip');
        if ($emojiTooltip.search('is visible')) {
            const keyEvent = $.Event('keydown');
            keyEvent.which = 27;
            $emojiTooltip.find('input').trigger(keyEvent);
            return true;
        }
        return false;
    },
    onKeyDown({view, event}) {
        if (event.key === "Backspace") {
          setTimeout(() => {
            const $position = view.state.selection.$from;
            const match = suggestionsTrigger()($position);
            if (match) {
              showEmojiList(view, match.range, match.text.slice(1));
            }
            return null;
          });
        }

        const $emojiTooltip = $('#emoji-tooltip');
        if ($emojiTooltip.search('is visible') && ['Tab', 'PageUp', 'PageDown', 'Escape', 'ArrowUp', 'ArrowDown', 'Enter'].includes(event.key)) {
            const keyEvent = $.Event('keydown');
            keyEvent.which = event.keyCode;
            $emojiTooltip.find('input').trigger(keyEvent);
            return true;
        }
        return false;
    }
});